import { motion } from 'framer-motion';
import { Search, MapPin, Landmark, Scale, KeyRound } from 'lucide-react';

const services = [
  { icon: Search, title: 'Search & Shortlisting', description: 'We handpick properties that match your requirements, saving you time and effort in finding the perfect home.' },
  { icon: MapPin, title: 'Site Visit', description: 'Personalized property tours with expert guidance. We coordinate visits at your convenience, even virtually for NRIs.' },
  { icon: Landmark, title: 'Home Loan Assistance', description: 'End-to-end support with loan applications, documentation, and securing the best interest rates from top banks.' },
  { icon: Scale, title: 'Legal Support', description: 'Complete legal due diligence, title verification, and documentation to ensure a safe and transparent transaction.' },
  { icon: KeyRound, title: 'Unit Booking to Possession', description: 'We walk with you from booking your dream unit to handing over the keys. Seamless end-to-end support.' }
];

export const Services = () => {
  return (
    <section id="services" className="py-24 md:py-32 bg-background-secondary" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="text-center mb-16">
          <p className="text-xs md:text-sm uppercase tracking-widest text-brand-green mb-4" data-testid="services-subtitle">What We Offer</p>
          <h2 className="text-4xl md:text-5xl font-heading font-light text-text-primary" data-testid="services-title">Our Services</h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6" data-testid="services-list">
          {services.map((service, index) => (
            <motion.div key={service.title} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: index * 0.1 }} className="group p-6 rounded-lg border border-brand-green/10 bg-white hover:border-brand-green/30 hover:shadow-lg transition-all duration-500 text-center" data-testid={`service-${index}`}>
              <div className="inline-flex items-center justify-center w-14 h-14 mb-5 rounded-full bg-brand-green/10 group-hover:bg-brand-green/10 transition-all duration-300">
                <service.icon className="text-brand-green group-hover:text-brand-green transition-colors" size={24} />
              </div>
              <h3 className="text-lg font-heading text-text-primary mb-3">{service.title}</h3>
              <p className="text-text-secondary text-sm font-light leading-relaxed">{service.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
